import { useState } from 'react';

function DescriptionBlock({ item }) {
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => setExpanded((prev) => !prev);

  const isLong = item.description.length > 50;
  const previewText = item.description.slice(0, 50);

  return (
    <div className="">
      <div className="border-0">
        {isLong ? (
          expanded ? (
            <>
              <div>{item.description}</div>
              <button
                className="btn btn-link p-0"
                style={{ fontWeight: 'bold' }}
                onClick={toggleExpand}
                aria-expanded="true"
              >
                <i className="bi bi-caret-up-fill"></i>
              </button>
            </>
          ) : (
            <>
              <div>
                {previewText}
                <button
                  className="btn btn-link p-0 align-baseline"
                  style={{ textDecoration: 'none', fontWeight: 'bold' }}
                  onClick={toggleExpand}
                  aria-expanded="false"
                >
                  <i className="bi bi-caret-down-fill"></i>
                </button>
              </div>
            </>
          )
        ) : (
          <div>{item.description}</div>
        )}
      </div>
    </div>
  );
}

export default DescriptionBlock;